import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "../../public/ssplasticlogo.webp";

export const Footer = () => {
  return (
    <footer className="bg-eerie-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center">
                <img
                  src={logo}
                  alt="SS Plastic Logo"
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Leading FRP manufacturer in India offering precision-engineered
              solutions for industrial applications.
            </p>
            <div className="text-xs text-gray-500">
              GST: 24BIRPS4800G2Z3
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <div className="space-y-2">
              <Link
                to="/"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                About Us
              </Link>
              <Link
                to="/products"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Products
              </Link>
              <Link
                to="/gallery"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Gallery
              </Link>
              <Link
                to="/contact"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Products */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Products</h3>
            <div className="space-y-2">
              <Link
                to="/product/pickling-acid-rec-tank"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Storage Tanks
              </Link>
              <Link
                to="/product/pipes-and-fittings"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Pipes & Fittings
              </Link>
              <Link
                to="/product/frp-pp-frp-ductings"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                FRP / PP FRP Ductings
              </Link>
              <Link
                to="/product/frp-scrubbers-and-stack"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Scrubbers & Stack
              </Link>
              <Link
                to="/product/industrial-vessels"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Industrial Vessels
              </Link>
              <Link
                to="/product/motor-cover-frp-gutter"
                className="block text-gray-300 hover:text-amber text-sm transition-colors"
              >
                Motor Cover & FRP Gutter
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Info</h3>
            <div className="space-y-3">
              <a
                href="tel:+919825850501"
                className="flex items-center gap-3 text-gray-300 hover:text-amber text-sm transition-colors"
              >
                <Phone className="h-4 w-4 text-amber shrink-0" />
                +91 98258 50501
              </a>
              <a
                href="tel:+919825850501"
                className="flex items-center gap-3 text-gray-300 hover:text-amber text-sm transition-colors"
              >
                <Phone className="h-4 w-4 text-amber shrink-0" />
                +91 98258 50501
              </a>
              <a
                href="mailto:info@ss-plastic.com"
                className="flex items-center gap-3 text-gray-300 hover:text-amber text-sm transition-colors"
              >
                <Mail className="h-4 w-4 text-amber shrink-0" />
                info@ss-plastic.com
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-amber mt-0.5 shrink-0" />
                <span className="text-gray-300 text-sm">
                  Vapi, Gujarat, India
                  <br />
                  Pin: 396195
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} SS Plastic. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <Link
              to="/contact"
              className="text-gray-400 text-sm hover:text-amber transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/contact"
              className="text-gray-400 text-sm hover:text-amber transition-colors"
            >
              Terms of Service
            </Link>
            <span className="text-gray-400 text-sm">ISO 9001:2015</span>
          </div>
        </div>
      </div>
    </footer>
  );
};